module.exports = __webpack_public_path__ + "img/filter-type-lowerbody--active.e370ad9a.svg";